import './qtyInput.scss';

import React from 'react';
import { useAvailabilityInfo } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';

QtyInput.defaultProps = {
    min: 0,
    max: null,
    step: 1,
    //precision={2}
};

function QtyInput(props) {
    const { qtyValue, setQtyValue, product } = props;

    // maybe change to OnBlur, requires an OnChange
    const handleManualChange = (event) => {
        setQtyValue(Number(event.target.value));
    };

    const handleIncrease = (event) => {
        event.stopPropagation();
        setQtyValue(qtyValue + props.step);
    };

    const handleDecrease = (event) => {
        event.stopPropagation();
        if (qtyValue - props.step >= props.min) {
            setQtyValue(qtyValue - props.step);
        } else {
            // cannot go lower
        }
    };

    const allowAddToCart = product
        ? useAvailabilityInfo(product).allowAddToCart
        : true;

    if (allowAddToCart)
        return (
            <div className='qtyInput'>
                <button type='button' onClick={handleDecrease}>
                    -
                </button>

                <input
                    className='qtyInputElement'
                    type='number'
                    min={props.min}
                    max={props.max}
                    step={props.step}
                    value={qtyValue}
                    onChange={handleManualChange}
                    onClick={(event) => event.stopPropagation()}
                />

                <button type='button' onClick={handleIncrease}>
                    +
                </button>
            </div>
        );

    return null;
}

export default QtyInput;
